/** "Extracted clauses" beside a file that has a document register, linking to it. Every badge
 * on a page reads from ONE /registers/for-documents call through the provider, never a
 * request per row (principle 8). */
import { createContext, type ReactNode, useContext } from "react";
import { Link } from "react-router-dom";

import { useRegistersForDocuments } from "../api";
import type { DocumentRegister } from "../api";
import { clausePagePath } from "../routes/learningAgentPaths";
import styles from "./Clauses.module.css";
import { registerChip } from "./registerChip";

const RegistersContext = createContext<Record<string, DocumentRegister>>({});

export const RegistersForDocumentsProvider = ({
  documentIds,
  children,
}: {
  documentIds: string[];
  children: ReactNode;
}) => {
  const registers = useRegistersForDocuments(documentIds).data ?? {};
  return (
    <RegistersContext.Provider value={registers}>
      {children}
    </RegistersContext.Provider>
  );
};

export const RegisterBadge = ({
  documentId,
  projectId,
}: {
  documentId: string;
  /** The project the page is on; null on Global data. */
  projectId: string | null;
}) => {
  const register = useContext(RegistersContext)[documentId];
  if (!register) return null;
  const { label, tone } = registerChip(register);
  return (
    <Link
      to={clausePagePath(register, projectId)}
      className={`${styles.chip} ${tone}`}
      style={{ marginLeft: 6 }}
      title="Every clause of this document, and where each requirement stands"
    >
      {label}
    </Link>
  );
};
